export default __webpack_public_path__ + "static/media/chevron-blue-badge.09987e4a.svg";